var map = {
	"./aparthotelclub/ic_amenities.png": 63705,
	"./beachful/ic_amenities.png": 39487,
	"./castlepedia/ic_amenities.png": 57499,
	"./cocktayl/ic_amenities.png": 17978,
	"./ic_amenities.png": 88714,
	"./luxresortclub/ic_amenities.png": 22369,
	"./parkful/ic_amenities.png": 12761,
	"./prefabworld/ic_amenities.png": 23318,
	"./rooftopclub/ic_amenities.png": 99748,
	"./spaclub/ic_amenities.png": 77301,
	"./worldcasino/ic_amenities.png": 56685,
	"./zoopedia/ic_amenities.png": 80875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76821;